import React from 'react'
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import {
  renderFieldNumeros, required
} from '../../util/inputs';

export class ModalImpressaoReciboPedido extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  fecharModal () {
    $('#modalImpressaoReciboPedido')
      .modal('hide');
    $('#modalImpressaoReciboPedido')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  submit (values) {
    this.fecharModal();
    this.props.history.push(`/recibo-passagem?pedido=${values.numeroPedido}`)
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalImpressaoReciboPedido' role='dialog'
           aria-labelledby='modalImpressaoReciboPedido' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-md'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Imprimir recibo</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit.bind(this))}>
                <div className="form-row mb-4">
                  <div className="col-12 col-sm-9 col-md-12">
                    <Field name="numeroPedido" type="text" component={renderFieldNumeros} validate={[required]} label="Número do pedido:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Confirmar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(null, {})(reduxForm({
  form: 'formImpressaoRecibo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalImpressaoReciboPedido)));
